import React, { useEffect, useState } from "react";
import { useTender } from "../../contexts/TenderContext";
import { Outlet, useLocation } from "react-router-dom";
import StepperNavigation from "../common/StepperNavigation";

const WorkflowContainer: React.FC = () => {
  const { setActiveJobType } = useTender();
  const location = useLocation();

  // Mirrors MainLayout's sidebar-collapse state (kept in sync via the
  // "sidebarCollapseRequest" event MainLayout dispatches on toggle) so the
  // stepper's left offset/width stay correct without remounting per page.
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = sessionStorage.getItem("sidebarCollapsed");
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    const handler = (e: Event) => {
      const collapsed = (e as CustomEvent<{ collapsed: boolean }>).detail?.collapsed;
      if (typeof collapsed === "boolean") setSidebarCollapsed(collapsed);
    };
    window.addEventListener("sidebarCollapseRequest", handler);
    return () => window.removeEventListener("sidebarCollapseRequest", handler);
  }, []);

  // Update active job type based on current URL
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/roads-sewers/')) {
      setActiveJobType('roadsAndSewers');
    } else if (path.startsWith('/groundworks/')) {
      setActiveJobType('groundworks');
    }
  }, [location.pathname, setActiveJobType]);

  return (
    <>
      <StepperNavigation showSidebar sidebarWidth={sidebarCollapsed ? 64 : 220} />
      <Outlet />
    </>
  );
};

export default WorkflowContainer;